import { i18n } from "../../../../i18n";
import { fbFunctions } from "@/config/firebase";

const fb = require('../../../../config/firebase.js')
import router from '@/router'

const state = () => ({
    createAdvertisement: {
        avatar: "",
        title: "",
        link: "",
        limitClicks: null,
        limitViews: null,
        language: "",
        content: "",
        isActive: false,
        isForMobile: false,
        isForWeb: false,
        isClickable: false,
    },
    editAdvertisement: {
        avatar: "",
        title: "",
        link: "",
        limit_clicks: null,
        limit_views: null,
        language: "",
        content: "",
        is_active: false,
        is_for_mobile: false,
        is_for_web: false,
        is_clickable: false,
    },
    editAdvertisementLoaded: false,
})

const getters = {}

const actions = {
    createAdvertisement({ commit, state }) {
        let vm = this;
        let saveProfileInfos = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'createAdvertisement',
            parameters: {
                'avatar': state.createAdvertisement.avatar,
                'content': state.createAdvertisement.content,
                'isActive': state.createAdvertisement.isActive,
                'isClickable': state.createAdvertisement.isClickable,
                'isForMobile': state.createAdvertisement.isForMobile,
                'isForWeb': state.createAdvertisement.isForWeb,
                'language': state.createAdvertisement.language,
                'limitClicks': state.createAdvertisement.limitClicks,
                'limitViews': state.createAdvertisement.limitViews,
                'link': state.createAdvertisement.link,
                'title': state.createAdvertisement.title,
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_ADVERTISEMENT_CREATED") {
                swal.fire(
                    i18n.t("administration.admin.app_create_advertisement.modal_save_success_title"),
                    i18n.t("administration.admin.app_create_advertisement.modal_save_success_content"),
                    "success"
                );
                router.push('dashboard')
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    "error"
                )
            }
        })
        .catch((e) => {
            console.log(e);
            swal.fire(
                i18n.t("administration.admin.global.modal_generic_error_title"),
                i18n.t("administration.admin.global.modal_generic_error_title"),
                "error"
            )
        });
    },
    fetchAdvertisementData({ commit, state }, payload) {
        fb.admininistrationCollection.doc("administration_announcements").collection("administration_announcements_ads")
            .doc(payload.advertisementId)
            .get()
            .then(function(doc) {
                if (doc.exists) commit('setEditAdvertisementData', doc.data());
                commit('setEditAdvertisementLoaded', true);
            })
            .catch(function(error) {
                console.log("Error getting document:", error);
            });
    },
    editAdvertisement({ commit, state }) {
        let vm = this;
        let saveProfileInfos = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'updateAdvertisement',
            parameters: {
                'avatar': state.editAdvertisement.avatar,
                'advertisementId': state.editAdvertisement.id,
                'content': state.editAdvertisement.content,
                'isActive': state.editAdvertisement.is_active,
                'isClickable': state.editAdvertisement.is_clickable,
                'isForMobile': state.editAdvertisement.is_for_mobile,
                'isForWeb': state.editAdvertisement.is_for_web,
                'language': state.editAdvertisement.language,
                'limitClicks': state.editAdvertisement.limit_clicks,
                'limitViews': state.editAdvertisement.limit_views,
                'link': state.editAdvertisement.link,
                'title': state.editAdvertisement.title,
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_ADVERTISEMENT_UPDATED") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                );
                router.push('dashboard')
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    "error"
                )
            }
        })
        .catch((e) => {
            console.log(e);
            swal.fire(
                i18n.t("administration.admin.global.modal_generic_error_title"),
                i18n.t("administration.admin.global.modal_generic_error_title"),
                "error"
            )
        });
    },
    deleteAdvertisement({ commit, state }) {
        let vm = this;
        let saveProfileInfos = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'deleteAdvertisement',
            parameters: {
                'advertisementId': state.editAdvertisement.id,
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_ADVERTISEMENT_DELETED") {
                swal.fire(
                    i18n.t("administration.admin.app_edit_advertisement.modal_delete_success_title"),
                    i18n.t("administration.admin.app_edit_advertisement.modal_delete_success_content"),
                    "success"
                );
                router.push('dashboard')
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    "error"
                )
            }
        })
        .catch((e) => {
            console.log(e);
            swal.fire(
                i18n.t("administration.admin.global.modal_generic_error_title"),
                i18n.t("administration.admin.global.modal_generic_error_title"),
                "error"
            )
        });
    },
}

const mutations = {
    setCreateAdvertisementField(state, val) {
        state.createAdvertisement[val.fieldToEdit] = val.fieldToEditValue;
    },
    setEditAdvertisementData(state, val) {
        state.editAdvertisement = val;
    },
    setEditAdvertisementLoaded(state, val) {
        state.editAdvertisementLoaded = val;
    },
    setEditAdvertisementField(state, val) {
        state.editAdvertisement[val.fieldToEdit] = val.fieldToEditValue;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/pages/admin/appAdvertisements.js